/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import extend from 'extend';

require('highcharts/highcharts-more.js')(Highcharts);
require('highcharts/modules/solid-gauge.js')(Highcharts);
require('highcharts/modules/bullet.js')(Highcharts);

class HighChartsGaugeVisualizer extends Component {
  render() {
    const { options } = this.props;
    const { data } = this.props;

    Highcharts.setOptions({
      global: {
        useUTC: false,
      },
    });

    const value = data[0].filter(d => d.name === 'currentCount')[0].data[0];
    const maxValue = data[0].filter(d => d.name === 'totalCount')[0].data[0];

    const highchartOptions = {
      chart: {
        backgroundColor: '#fefefe',
        zoomType: 'x',
        type: 'solidgauge',
        height: 190,
      },
      title: {
        text: '',
      },
      yAxis: {
        min: 0,
        max: maxValue.y,
        tickInterval: 1,
        tickWidth: 0,
        tickPositioner() {
          return [0, maxValue.y];
        },
        title: {
          text: '',
        },
      },
      xAxis: {
        visible: false,
      },
      credits: {
        enabled: false,
      },
      colors: [
        '#882c66', '#066B7F', '#353535', '#01172F', '#8BB73E',
      ],
      series: [{
        name: value.name,
        data: [value.y],
        dataLabels: {
          format: `${'<div style="text-align:center"><span style="font-size:25px;color:black">{y}</span><br/>'
                  + '<span style="font-size:12px;color:silver">'}${value.y} ${value.name}</span></div>`,
        },
      }],
    };

    // merge additional options
    extend(true, highchartOptions, options);


    // overwrite properties to enforce bullet chart, ideally this should be configured in db
    highchartOptions.chart = {
      type: 'bullet',
      inverted: true,
      height: 80,
      margin: 1,
      marginBottom: 30,
    };

    highchartOptions.tooltip = {
      enabled: true,
      formatter: () => `${value.name}: <b>${value.y}</b>`,
    };

    return <HighchartsReact highcharts={Highcharts} options={highchartOptions} />;
  }
}

HighChartsGaugeVisualizer.propTypes = {
  data: PropTypes.array,
  options: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
};

HighChartsGaugeVisualizer.defaultProps = {
  data: [],
  options: [],
};

export default HighChartsGaugeVisualizer;
